/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import useLedgers from "../../hooks/useLedgers";
import CommonTable from "../../components/CommonTable";
import { LedgerTabledata, Table } from "../setting/settingInterface";
import { TablePagination } from "@mui/material";
import LoadingScreen from "../../../../shared/components/LoadingScreen";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSearch } from "../../components/SearchContext";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "../../hooks/tableConfig";
import { useUser } from "../../components/UserContext";
import { FontColor } from "src/shared/modules/profile/theme/themeCheacker";
import { reactAppVersion } from "src/features/auth/axiosConfig";

const ledgerTable: Table<LedgerTabledata>[] = [
  { id: "S.No", label: "S.No", numeric: false, sorting: false },
  { id: "customerName", label: "Customer Name", numeric: false },
  { id: "customerPhoneNo", label: "Phone Number", numeric: false },
  { id: "outstandingBalance", label: "Outstanding Balance", numeric: true },
];

function LedgerTable() {
  const { searchTerm, setSearchTerm } = useSearch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigation = useNavigate();
  //sorting
  const [orderby, setOrderBy] = useState("");
  const [field, setField] = useState("");
  const [osbAvabile, setOSBAvabile] = useState<boolean>(false);
  const { ledgers, loading } = useLedgers(page + 1, rowsPerPage, searchTerm, field, orderby, osbAvabile);
  const [pagenation, setPagenation] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { userConfigration } = useUser();

  useEffect(() => {
    const pageParam = Number(searchParams.get("page")) || 1;
    const limitParam = Number(searchParams.get("limit")) || 10;
    setPage(pageParam - 1);
    setRowsPerPage(limitParam);
    setSearchTerm(searchParams.get("search") || "");
  }, [searchParams]);

  useEffect(() => {
    setRowsPerPage(userConfigration?.tableDefaultSize);
  }, [userConfigration]);

  const handleChangePage = (_: unknown, newPage: number) => {
    setSearchParams({
      page: (newPage + 1).toString(),
      limit: rowsPerPage.toString(),
      search: searchTerm,
    });
  };

  useEffect(() => {
    setPagenation(ledgers?.pageNumber === null);
  }, [ledgers]);

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newLimit = parseInt(event.target.value, 10);

    setSearchParams({
      page: "1",
      limit: newLimit.toString(),
      search: searchTerm,
    });
  };

  const LedgerList: LedgerTabledata[] =
    ledgers?.result.map((item, index) => ({
      "S.No": page * rowsPerPage + index + 1,
      id: item.customerId.toString() || "",
      customerName: `${item.firstName} ${item.middleName} ${item.lastName}`,
      customerPhoneNo: String(item.phones[0]?.phone),
      outstandingBalance: Number(item.totalOutstandingBalance || 0).toFixed(2),
    })) || [];

  return (
    <div className='w-full h-[86%] p-2'>
      {(loading || !ledgers) && <LoadingScreen />}
      <div className='w-full h-fit flex justify-around items-center mb-4'>
        <div className='w-fit p-2 bg-gray-200 border border-gray-300 rounded-lg grid'>
          <h1 className='text-xl font-semibold pr-10'>Total records</h1>
          <h1 className='text-4xl font-semibold text-center'>{ledgers?.totalRecords}</h1>
        </div>
        <div className='w-fit p-2 bg-gray-200 border border-gray-300 rounded-lg grid'>
          <h1 className='text-xl font-semibold pr-10'>Over All Outstanding Balance</h1>
          <h1 className='text-4xl font-semibold text-center'>{ledgers?.total_outstanding_balance.toFixed(2)}</h1>
        </div>
      </div>

      <div className='w-full h-full overflow-auto border border-gray-200 bg-gray-200 shadow-inner rounded-xl m-1 p-2'>
        <div className='m-1 overflow-auto h-fit w-[99%] flex justify-center bg-white p-1 rounded-lg shadow-lg'>
          <div className='w-full flex flex-col justify-center items-center'>
            <div className='h-fit w-full'>
              <div className='flex gap-2 w-full justify-end items-end -mb-10 px-16 pt-4'>
                <span className={osbAvabile === false ? `${FontColor()} font-semibold` : "text-gray-500"}>With ledger Balance</span>
                <label className='relative inline-flex items-center cursor-pointer'>
                  <input
                    type='checkbox'
                    className='sr-only peer'
                    checked={osbAvabile === true}
                    onChange={() => setOSBAvabile(!osbAvabile)}
                    aria-label='Toggle discount mode'
                  />
                  <div className="w-11 h-6 bg-gray-300 rounded-full peer-checked:bg-blue-600 transition-all relative after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full"></div>
                </label>
                <span className={osbAvabile === true ? `${FontColor()} font-semibold` : "text-gray-500"}>All customer</span>
              </div>
              <CommonTable<LedgerTabledata>
                data={LedgerList}
                headCells={ledgerTable}
                title='Ledger List'
                selectable={false}
                pageSize={rowsPerPage}
                pagenation={pagenation}
                onRowClick={(ledgerId) => {
                  navigation(`/grocery/${reactAppVersion}/ledgers/${ledgerId}`);
                }}
                shortByTable={false}
                OrderType={(data) => {
                  setField(data.field);
                  setOrderBy(data.orderby);
                }}
              />
            </div>
            {!pagenation && (
              <div className='w-[95%] bg-white border end -mt-2 rounded-b-md '>
                <TablePagination
                  rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
                  component='div'
                  count={ledgers?.totalRecords || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LedgerTable;
